import styles from './AboutUsPageDark.module.scss';

import { AboutHeadDark } from './components/Hero/AboutHeadDark';
import { GetStarted } from './components/GetStarted/GetStarted';
import { SectionNavigation } from './components/SectionNavigation/SectionNavigation';
import { AboutMission } from './components/AboutMission/AboutMission';
import { AboutTeam } from './components/AboutTeam/AboutTeam';
import { ExpertsFromSection } from './components/ExpertsFromSection/ExpertsFromSection';
import { AboutCounsel } from './components/AboutCounsel/AboutCounsel';
import { useWindowSize } from '~/hooks/useWindowSize';

export const AboutUsPageDark = () => {
    const { isMobile } = useWindowSize();

    return (
        <div className={styles.container}>
            <AboutHeadDark />
            <SectionNavigation />
            <AboutMission />
            <AboutTeam />
            {!isMobile && <ExpertsFromSection />}
            <AboutCounsel />
            <GetStarted />
        </div>
    );
};
